import {
  Component,
  Input,
  AfterContentChecked,
  OnDestroy,
  ViewChild,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SubSink } from "subsink";

import { ConfigurationService } from "@/shared-module/services";
import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-demodialog",
  templateUrl: "demodialog.component.html",
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .btn-validate {
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 2px;
        padding: 12px 24px;
        background-color: #2d81ff;
        color: #ffffff;
        border-radius: 24px;
        margin-top: 16px;
        margin-right: 16px;
      }
      .btn-validate:disabled {
        background-color: #c9c9db;
      }
      .btn-validate {
        background-color: #ffffff;
        color: #00001f;
        border: 1px solid #c9c9db;
      }
      video {
        left: 50%;
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    `,
  ],
})
export class DemoDialogComponent implements AfterContentChecked, OnDestroy {
  @ViewChild("template", { static: true }) template;
  @ViewChild("content", { static: true }) content;
  @Input() data: any;
  @Output() validated: EventEmitter<string> = new EventEmitter();
  subs = new SubSink();
  cssColor: string;
  viewIndex = 0;
  selectedLanguageTexts: any;

  constructor(
    private configurationService: ConfigurationService,
    private modalService: NgbModal,
  ) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
      },
    );
  }

  selectLanguage(language) {
    this.configurationService.setLanguage(language).subscribe((s) => {
      this.viewIndex = 1;
      this.data.texts.forEach((t) => {
        if (t.language === language) {
          this.selectedLanguageTexts = t;
        }
      });
    });
  }

  goToLastView() {
    this.viewIndex = 2;
  }

  startSimulation() {
    this.configurationService.setDemoPopup(false);
    location.reload();
  }

  ngAfterContentChecked() {
    if (this.data && !this.selectedLanguageTexts) {
      if (this.data.texts.length >= 2) {
        this.viewIndex = 0;
      } else {
        this.selectLanguage(this.data.texts[0].language);
      }
    }
  }

  open() {
    this.modalService.open(this.content, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "modal-full modal-dialog-scrollable",
      size: "xl",
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
